import { render, staticRenderFns } from "./TrocaOpcionalPagamento.vue?vue&type=template&id=22d75758&scoped=true&"
import script from "./TrocaOpcionalPagamento.vue?vue&type=script&lang=js&"
export * from "./TrocaOpcionalPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TrocaOpcionalPagamento.vue?vue&type=style&index=0&id=22d75758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d75758",
  null
  
)

export default component.exports